import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createDevTools } from "@redux-devtools/core";
import ConfigClient, { PathArray } from "../../../clients/configClient";
import { System } from "../../../common/system";
import { logMonitor } from "./devtoolsEnhancer";
import { toPath } from "lodash";

// Uncomment this code and the associated imports to enable the ChartMonitor
/*
const theme = nicinabox;

const chartMonitorStyle = {
	width: "100%",
	height: "100%", // i.e fullscreen for DockMonitor
	text: {
		colors: {
			default: theme.base0D,
			hover: theme.base06,
		},
	},
	node: {
		colors: {
			default: theme.base0B,
			collapsed: theme.base0B,
			parent: theme.base0E,
		},
		radius: 5,
	},
};


const DevTools = createDevTools(
	<ChartMonitor style={chartMonitorStyle} widthBetweenNodesCoeff={1} heightBetweenNodesCoeff={2} />
);
*/

const DevTools = createDevTools(logMonitor);

/**
 * @params __namedParameters.actions - windowVisible() function to toggle the dev tools on and off
 * @params __namedParameters.field - The config field to determine visibility. e.g. "finsemble.services.interopService.visible"
 */
const DevToolsContainer = ({ windowVisible, field }: { windowVisible: any; field: string }) => {
	const dispatch = useDispatch();
	const isVisible = useSelector((store: any) => store.root.isVisible);

	const makeVisible = () => {
		//  Make certain visibility only runs once
		System.Window.getCurrent().removeEventListener("shown", makeVisible);
		window.removeEventListener("focus", makeVisible);
		if (!isVisible) dispatch(windowVisible(true));
	};

	useEffect(() => {
		const path: PathArray = toPath(field);
		ConfigClient.get(path, (err: any, isVisibleValue?: boolean) => {
			dispatch(windowVisible(!!isVisibleValue));
		});

		System.Window.getCurrent().addEventListener("shown", makeVisible);

		window.addEventListener("focus", makeVisible);
	}, []);

	return <>{isVisible && <DevTools />}</>;
};

export { DevToolsContainer };

export default DevTools;
